import React from 'react';

import { Glyph } from './WalletGlyph.styles';

/**
 * Owners-Hub wallet glyph — Figma node 6534:20119 (Spark Configurator). Drawn
 * inline (not via `<img>`) so the nav's active/hover `path[fill]` rule can
 * recolour it (the mask-based `MaskIcon` glyphs it sits beside recolour via
 * background-color instead).
 *
 * The paths are normalised to `fill="currentColor"`: the rest colour comes from
 * the wallet-icon token on the `Glyph` wrapper, the active colour from the
 * parent nav item's recolour rule. The wrapper renders an svg sized by the
 * chrome's `.icon svg` / `.drawer-icon svg` rules unchanged.
 */
export type WalletGlyphProps = {
  size?: number;
  className?: string;
};

export const WalletGlyph = ({ size = 24, className }: WalletGlyphProps): React.ReactElement => (
  <Glyph className={className} aria-hidden="true">
    <svg width={size} height={size} viewBox="0 0 22 21.6097" fill="none">
      <path
        fill="currentColor"
        d="M5.14118 4.11351L13.9115 1.6639L13.4471 0.703272C13.1432 0.0788623 12.402 -0.178991 11.7918 0.13195L3.94051 4.11351H5.14118Z"
      />
      <path
        fill="currentColor"
        d="M16.634 1.73474C16.5254 1.73474 16.4166 1.74991 16.3079 1.78024L14.2475 2.35662L7.95509 4.11356H15.0974H18.2102L17.8248 2.66756C17.6766 2.10382 17.1775 1.73474 16.634 1.73474Z"
      />
      <path
        fill="currentColor"
        d="M19.4974 4.99836H19.2157H18.8328H18.4499H15.5272H4.78787H3.37967H2.19382H1.97395H1.23773C0.847389 4.99836 0.499045 5.18291 0.271757 5.47362C0.167996 5.60761 0.0889388 5.76181 0.0444694 5.93119C0.0172937 6.03736 0 6.14859 0 6.26235V6.41403V7.85498V20.3457C0 21.0435 0.553397 21.6097 1.23526 21.6097H19.4949C20.1768 21.6097 20.7302 21.0435 20.7302 20.3457V16.8192H13.4001C12.2414 16.8192 11.3002 15.856 11.3002 14.6704V13.5126V13.1208V12.7289V11.8593C11.3002 11.2779 11.5274 10.7495 11.8956 10.3628C12.2217 10.0189 12.659 9.78635 13.1481 9.72821C13.2296 9.71812 13.3136 9.71304 13.3976 9.71304H19.7024H20.0853H20.4683H20.7302V6.26235C20.7326 5.56463 20.1792 4.99836 19.4974 4.99836Z"
      />
      <path
        fill="currentColor"
        d="M21.5973 10.9213C21.4738 10.805 21.328 10.7165 21.165 10.6584C21.0389 10.6155 20.9055 10.5902 20.7647 10.5902H20.7326H20.7079H20.325H18.944H13.4001C12.7182 10.5902 12.1648 11.1564 12.1648 11.8542V12.4836V12.8754V13.2673V14.6678C12.1648 15.3655 12.7182 15.9318 13.4001 15.9318H20.7326H20.7647C20.9055 15.9318 21.039 15.9065 21.165 15.8635C21.328 15.8079 21.4738 15.7169 21.5973 15.6006C21.8443 15.3706 22 15.0369 22 14.6678V11.8542C22 11.4851 21.8443 11.1513 21.5973 10.9213ZM15.9793 13.5125C15.9793 13.8613 15.7026 14.1445 15.3617 14.1445H14.9516C14.6107 14.1445 14.334 13.8613 14.334 13.5125V13.0928C14.334 12.8906 14.4254 12.7111 14.5711 12.5973C14.6774 12.5139 14.8083 12.4609 14.9516 12.4609H15.0554H15.3617C15.7026 12.4609 15.9793 12.744 15.9793 13.0928V13.5125Z"
      />
    </svg>
  </Glyph>
);

export default WalletGlyph;
